module.exports = __webpack_public_path__ + "static/media/appcenterLogo.c9c98bf4.svg";